import React,{lazy, Suspense} from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useLayoutEffect } from "react";
import Layout from "./../theme/layout";
import BasePage from "./Basepage";
import Loader from "./view/components/common/loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
const Login = lazy(() =>
  import("./view/pages/auth/login" /* webpackChunkName: "admin_login" */)
);
const Logout = lazy(() =>
  import(
    "./view/pages/auth/logout" /* webpackChunkName: "admin_logout" */
  )
);
const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};
function App() {
  const admin = useSelector((state) => state.admin);
  const isLogin = () => {
    return Object.keys(admin).length != 0;
  };
  return (
    <Suspense fallback={<Loader />}>
      <>
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          limit={2}
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </>
      <BrowserRouter>
        <Wrapper>
          <Routes>
            <Route
              path="/auth/login"
              element={
                <div className="dir-rtl">
                  <Login />
                </div>
              }
            />
            <Route
              path="/auth/logout"
              element={
                <div className="dir-rtl">
                  <Logout />
                </div>
              }
            />
            <Route
              path="*"
              element={
                isLogin() ? (
                  <Layout>
                    <BasePage />
                  </Layout>
                ) : (
                  <Navigate to={"/auth/login"} />
                )
              }
            />
          </Routes>
        </Wrapper>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
